import * as ConfigActions from "./ConfigActions";
// import * as HomeActions from "screens/HomeScreen/actions";
import * as UserActions from "./UserActions";
import * as BreadcrumbActions from "./BreadcrumbActions";
import * as SiteActions from "pages/Site/actions";
import * as StoreActions from "pages/Store/actions";
import { ActionCreatorsMapObject } from "redux";

const actions: ActionCreatorsMapObject<any> = {
  ...ConfigActions,
  ...UserActions,
  ...SiteActions,
  ...BreadcrumbActions,
  ...StoreActions,
};

export default actions;
